/*
 * Offer Childs Messages
 *
 * This contains all the text for the OfferChilds component.
 */
import { defineMessages } from 'react-intl';
import configs from "configs"

export const scope = 'app.components.OfferChilds';

export default defineMessages({
  note: {
    id: `${scope}.note`,
    defaultMessage:
      'Per la creazione delle Variazioni è neccessario inserire <strong>2 Anticipi, 2 Durate e 3 Km/Anno</strong>.',
    title: 'Note',
  },

  childs: {
    id: `${scope}.childs`,
    defaultMessage: 'Inserisci il prezzo di ogni variazione',
    title: 'Prezzi',
  },

  childsDisabled: {
    id: `${scope}.childsDisabled`,
    defaultMessage:
      "Prima di procedere con l'aggiunta delle variazioni assicurati di aver compilato tutti i sovrastanti",
  },

  durations: {
    id: `${scope}.durations`,
    defaultMessage: 'Durata',
  },

  deposits: {
    id: `${scope}.deposits`,
    defaultMessage: 'Anticipo',
  },

  distances: {
    id: `${scope}.distances`,
    title: 'Distanze',
    defaultMessage: 'Seleziona il numero di chilometri su base annua',
    unit: 'Km',
    unitDescription: 'Km/Anno',
  },

  distance: {
    id: `${scope}.distance`,
    title: 'Distanza',
    defaultMessage: 'Seleziona il numero di chilometri su base annua',
    unit: 'Km',
    unitDescription: 'Km/Anno',
  },

  deposit: {
    id: `${scope}.deposit`,
    title: 'Anticipo',
    defaultMessage: configs.messages[scope].deposit,
    name: 'deposit',
  },

  price: {
    id: `${scope}.price`,
    title: 'Canone Mensile',
    defaultMessage: configs.messages[scope].price,
    name: 'price',
  },

  duration: {
    id: `${scope}.duration`,
    title: 'Durata',
    defaultMessage: 'Seleziona una seconda durata',
    unit: 'Mesi',
    unitDescription: 'Mesi',
  },

  actions: {
    id: `${scope}.actions`,
    defaultMessage: '',
    title: 'Azioni',
    add: 'Aggiungi variazione',
    remove: 'Elimina variazione'
  }
});
